webpackJsonp([270357501840163],{

/***/ 113:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioGrid = function PortfolioGrid(_ref) {
	  var title = _ref.title,
	      items = _ref.items,
	      categorySlug = _ref.categorySlug;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-grid' },
	      items.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'portfolio-grid-item', key: item.slug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug + item.slug },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: item.thumbnailSizes })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = PortfolioGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PortfolioGrid = __webpack_require__(82);
	
	var _PortfolioGrid2 = _interopRequireDefault(_PortfolioGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import React from 'react'
	// import Img from 'gatsby-image'
	
	// import NoContent from '../../components/NoContent'
	
	// const PaintingPage = ({ data }) => {
	//   const items =
	//     data.allFile === null
	//       ? []
	//       : data.allFile.edges.map(item => {
	//           return {
	//             sizes: item.node.childImageSharp.sizes,
	//             id: item.node.id
	//           }
	//         })
	
	//   return (
	//     <div>
	//       <div className="portfolio-title">paintings</div>
	//       <div className="portfolio-list">
	//         {items.length === 0 ? (
	//           <NoContent />
	//         ) : (
	//           items.map(item => (
	//             <Img className="portfolio-item" sizes={item.sizes} key={item.id} />
	//           ))
	//         )}
	//       </div>
	//     </div>
	//   )
	// }
	
	// export default PaintingPage
	
	// export const query = graphql`
	//   query PaintingQuery {
	//     allFile(
	//       filter: {
	//         extension: { eq: "jpg" }
	//         absolutePath: { regex: "/(painting)/" }
	//       }
	//     ) {
	//       edges {
	//         node {
	//           id
	//           childImageSharp {
	//             sizes(maxWidth: 640) {
	//               ...GatsbyImageSharpSizes
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	// `
	
	var PaintingPage = function PaintingPage(_ref) {
	  var data = _ref.data;
	
	  var items = data.allFile.edges.map(function (item) {
	    return item.node.fullImage === null ? null : {
	      fullSizes: item.node.fullImage.sizes,
	      thumbnailSizes: item.node.thumbnail.sizes,
	      name: item.node.name,
	      slug: item.node.fields.slug
	    };
	  }).filter(function (item) {
	    return item !== null;
	  });
	
	  return _react2.default.createElement(_PortfolioGrid2.default, { items: items, title: 'painting', categorySlug: '/painting' });
	};
	
	exports.default = PaintingPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-painting-index-js-7d95a3e78c31f79bec0c.js